type ImagePath = {
  dimensions?: string;
  fitBackground?: string;
  quality?: number | string;
  url: string;
};

const getImagePath = ({
  dimensions = '[DIMENSIONS]',
  fitBackground,
  quality = '[QUALITY]',
  url,
}: ImagePath) => {
  return [
    'https://img.thecollector.io',
    url.replace('https://a.storyblok.com', ''),
    '/m/',
    fitBackground ? 'fit-in/' : '',
    dimensions,
    '/filters:',
    fitBackground ? `fill(${fitBackground.replace('#', '')}),` : '',
    `quality(${quality})`,
  ].join('');
};

export default getImagePath;
